<template>
    <span :style="{ color: color }">{{ formattedValue }}</span>
    <span v-if="tooltip" v-tippy="tooltip" class="ml-1">
        <font-awesome-icon icon="question-circle" class="h-4 w-4" />
    </span>
</template>

<script>
export default {
    props: {
        value: {
            type: [String, Number, Date, null], // Allow null
            required: false, // Not required
            default: null // Default to null
        },
        humanReadable: {
            type: Boolean,
            default: false
        },
        color: {
            type: String,
            default: 'black'
        },
        tooltip: {
            type: String,
            default: ''
        },
        past: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            formattedValue: null,
        }
    },

    mounted() {
        this.formatTime(this.value);
    },

    methods: {
        formatTime(input) {
            if (input === null) {
                this.formattedValue = 'No date';
                return;
            }

            let tempDate = input;
            let date = new Date(tempDate);
            let today = new Date();
            let yesterday = new Date(today);
            yesterday.setDate(yesterday.getDate() - 1);

            if (this.humanReadable) {
                if (date.toDateString() === today.toDateString()) {
                    this.formattedValue = 'Today';
                } else if (date.toDateString() === yesterday.toDateString()) {
                    this.formattedValue = 'Yesterday';
                } else {
                    let diffTime = date - today;
                    let diffDays = Math.ceil(Math.abs(diffTime) / (1000 * 60 * 60 * 24));

                    if (this.past && diffTime < 0) {
                        this.formattedValue = `${diffDays} days ago`;
                    } else if (!this.past && diffTime > 0) {
                        this.formattedValue = `in ${diffDays} day(s)`;
                    } else {
                        this.formattedValue = `${diffDays} day(s)`;
                    }
                }
            } else {
                let year = date.getFullYear();
                let month = ('0' + (date.getMonth() + 1)).slice(-2);
                let day = ('0' + date.getDate()).slice(-2);
                this.formattedValue = `${year}-${month}-${day}`;
            }
        }
    }
}
</script>